export default __webpack_public_path__ + "static/media/hong-kong.9c90898e.png";